/**
 * Worker Inbox Zustand Store Slice Types
 *
 * Internal state shape for inbox-related UI on the worker side. Lives
 * inside useWorkerStore as a slice — consumers use the stable selector
 * hooks exported from `@worker/stores/workerStore` and should not import
 * these internal types directly.
 */

export type RateCompanyModalState = Readonly<{
  isOpen: boolean;
  jobAssignmentId: number | null;
}>;

export type RequestRatingModalState = Readonly<{
  isOpen: boolean;
  jobAssignmentId: number | null;
  isValidatedCompany: boolean;
}>;

export type InboxState = Readonly<{
  rateCompanyModal: RateCompanyModalState;
  requestRatingModal: RequestRatingModalState;
}>;

export const DEFAULT_RATE_COMPANY_MODAL_STATE: RateCompanyModalState = {
  isOpen: false,
  jobAssignmentId: null,
} as const;

export const DEFAULT_REQUEST_RATING_MODAL_STATE: RequestRatingModalState = {
  isOpen: false,
  jobAssignmentId: null,
  isValidatedCompany: false,
} as const;

export const DEFAULT_INBOX_STATE: InboxState = {
  rateCompanyModal: DEFAULT_RATE_COMPANY_MODAL_STATE,
  requestRatingModal: DEFAULT_REQUEST_RATING_MODAL_STATE,
} as const;
